module.exports = __webpack_public_path__ + "img/grafico.7331fe53.svg";